import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs, Tab, TabList, TabPanel
} from 'react-tabs';
import { connect } from 'react-redux';

import { actionCreators } from 'react/api/actions/stockSummaryModal';
import { CustomProvider } from 'react/utils/renderUtils';
import * as selectors from 'react/api/selectors/stockSummaryModal';

import Modal from 'react/components/Modal';
import IntactSKUs from './IntactSKUs';
import DamagedSKUs from './DamagedSKUs';

class StockSummaryModal extends React.Component {
  constructor() {
    super();
    this.state = { tabIndex: 0 };
  }

  render() {
    const intactResource = Monet.I18n.getResourcesByKey('Greenmile.RouteMonitor.StockSummary.IntactStock.Tab');
    const damagedResource = Monet.I18n.getResourcesByKey('Greenmile.RouteMonitor.StockSummary.DamagedStock.Tab');

    const {
      isOpen,
      routeId,
      isLoading,
      closeAction,
      lastSyncText,
      ...others
    } = this.props;

    const { tabIndex } = this.state;

    return (
      <CustomProvider>
        <Modal
          isOpen={isOpen}
          closeModalFn={closeAction}
          style={{ width: '100%' }}
          {...others}
        >
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(i) => this.setState({ tabIndex: i })}
          >
            <TabList>
              <Tab>
                <div className="panel">
                  <div className="title">{intactResource}</div>
                </div>
              </Tab>

              <Tab>
                <div className="panel">
                  <div className="title">{damagedResource}</div>
                </div>
              </Tab>
            </TabList>

            <TabPanel>
              <IntactSKUs />
            </TabPanel>

            <TabPanel>
              <DamagedSKUs />
            </TabPanel>

            <div className="last-sync">
              {lastSyncText && <p>{lastSyncText}</p>}
            </div>
          </Tabs>
        </Modal>
      </CustomProvider>
    );
  }
}

StockSummaryModal.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  closeAction: PropTypes.func.isRequired,
  lastSyncText: PropTypes.string
};

StockSummaryModal.defaultProps = {
  isLoading: false,
  lastSyncText: null
};

const mapStateToProps = (state) => ({
  isOpen: selectors.getIsOpen(state),
  isLoading: selectors.getIsLoading(state)
});

const mapDispatchToProps = {
  closeAction: actionCreators.close
};

export default connect(mapStateToProps, mapDispatchToProps)(StockSummaryModal);
